import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "contents-title-text ma-4 text-black" };
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_GoodsListDialog = _resolveComponent("GoodsListDialog");
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    return (_ctx.hasOrderGoodsNames)
        ? (_openBlock(), _createBlock(_component_BarogoTooltip, {
            key: 0,
            "without-icon": "",
            "content-class": "tooltip elevation-3 pa-0"
        }, {
            activatorSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.order.goodsNames), 1 /* TEXT */)
            ]),
            tooltipMessage: _withCtx(() => [
                _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t(`${_ctx.lc}goods_list`)), 1 /* TEXT */),
                _createVNode(_component_v_divider),
                (_ctx.order !== null)
                    ? (_openBlock(), _createBlock(_component_GoodsListDialog, {
                        key: 0,
                        "order-id": _ctx.order.orderId
                    }, null, 8 /* PROPS */, ["order-id"]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, " - "));
}
